import {
  STATISTICS_FETCH_ERROR,
  STATISTICS_FETCH_PENDING,
  STATISTICS_FETCH_SUCCESS,
  STATISTICS_PAGE_SIZE,
  STATISTICS_RESET,
  STATISTICS_SET_PAGE,
  STATISTICS_SET_PAGE_SIZE,
  TStatisticsActions,
  TStatisticsHistoryItem,
} from "./actions";

type TStatisticsState = {
  items: TStatisticsHistoryItem[];
  count: number;
  page: number;
  pageSize: number;
  pending: boolean;
  error: string | null;
};

const initialState: TStatisticsState = {
  items: [],
  count: 0,
  page: 1,
  pageSize: STATISTICS_PAGE_SIZE,
  pending: false,
  error: null,
};

export const reducer = (state = initialState, action: TStatisticsActions): TStatisticsState => {
  switch (action.type) {
    case STATISTICS_SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case STATISTICS_SET_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      };
    case STATISTICS_FETCH_PENDING:
      return {
        ...state,
        pending: true,
        error: null,
      };
    case STATISTICS_FETCH_SUCCESS:
      return {
        ...state,
        pending: false,
        error: null,
        items: action.payload.items,
        count: action.payload.count,
      };
    case STATISTICS_FETCH_ERROR:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case STATISTICS_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
